// @flow
import { combineReducers } from 'redux';

import { customerSearch } from './customer-search/customerSearch.reducer';
import { proposalsReducer as proposals } from './proposals/proposals.reducer';
import { resortReducer as resort } from './resort/resort.reducer';
import selectedProposalId from './selected-proposal-id/selectedProposalId.reducer';
import bestProposalId from './best-proposal-id/bestProposalId.reducer';
import { additionalAccommodations } from './additional-accommodations/additionalAccommodations.reducer';
import additionalTransports from './additional-transports/additionalTransports.reducer';
import paymentProviders from './payment-providers/paymentProviders.reducer';
import { bookingEngineEntry } from './booking-engine-entry/bookingEngineEntry.reducer';
import { attendeesReducer as attendees } from './attendees/attendees.reducer';
import { suggestionsReducer as suggestions } from './suggestions/suggestions.reducer';

export const booking = combineReducers({
  additionalAccommodations,
  additionalTransports,
  attendees,
  bestProposalId,
  bookingEngineEntry,
  customerSearch,
  paymentProviders,
  proposals,
  resort,
  selectedProposalId,
  suggestions,
});
